import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || '';

export default function HistoryModal({ orderId, serviceId, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/assignmentHistory?orderId=${orderId}`)
      .then(r => r.json())
      .then(data => {
        setHistory(data.sort((a, b) => new Date(b.assignedTime) - new Date(a.assignedTime)));
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [orderId, serviceId]);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Assignment History</h3>
          <button className="modal-close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="20" height="20"><path d="M18 6L6 18M6 6l12 12" /></svg>
          </button>
        </div>
        <div className="modal-body">
          <p className="modal-subtitle">Order <strong>#{orderId}</strong></p>
          {loading ? (
            <div className="history-loading">Loading history...</div>
          ) : history.length === 0 ? (
            <div className="history-empty">No assignment history found for this order.</div>
          ) : (
            <div className="history-timeline">
              {history.map((entry, idx) => (
                <div key={entry.id} className={`timeline-item ${idx === 0 ? 'latest' : ''}`}>
                  <div className="timeline-dot" />
                  <div className="timeline-content">
                    <div className="timeline-header">
                      <strong>{entry.assigneeName}</strong>
                      <span className="timeline-stage">{entry.stageName}</span>
                    </div>
                    <div className="timeline-meta">
                      Assigned by {entry.assignedByName} &mdash;{' '}
                      {new Date(entry.assignedTime).toLocaleString('en-US', {
                        month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
                      })}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
